import { Flex } from 'antd';
import { useState } from 'react';
import HrModalWindow from '../../../../../Components/OpenAccessPageComponent/HRModalWindow/HrModlaWindow';
import { SidebarMenu } from '../../../../../shared/components/sidebar-menu';
import { NotificationProvider } from '../../../../../shared/hooks/useGlobalNotification';
import { DeviceIdProvider } from '../device-id-context';
import styles from './center-with-sidebar.module.css';
import { Translate } from '../../../../../Components/UI/Translate/Translate';

export const Layout_CenterWithSidebar = (props) => {
    const match = props.match || {};
    const { deviceId } = match.params || {};

    const [sidebarMenuOpen, setSidebarMenuOpen] = useState(false);
    const [hrModal, setHrModal] = useState(false);

    return (
        <NotificationProvider>
            <DeviceIdProvider deviceId={deviceId}>
                <SidebarMenu
                    id={deviceId}
                    open={sidebarMenuOpen}
                    onToggle={() => setSidebarMenuOpen(!sidebarMenuOpen)}
                    openHR={() => setHrModal(true)}
                />
                <HrModalWindow
                    bgOnClick={() => { setHrModal(false) }}
                    modalStatus={hrModal}
                    id={deviceId}
                />
                {/* <Flex className={styles.lang}>
                    <Translate hideFlags />
                </Flex> */}
                <Flex
                    align='center'
                    vertical
                    gap={5}
                    className={styles.app_container}
                    style={{
                        paddingLeft: (sidebarMenuOpen ? 367 : 90) + 30,
                        width: '100%',
                        // height: 'calc(100dvh - 69px)', Хз зачем это было
                        transition: 'padding-left 0.3s ease-in-out',
                    }}
                >
                    <Flex style={{ maxWidth: 1000, width: '100%' }} justify='flex-end'>
                        <Translate hideFlags />
                    </Flex>
                    {props.children}
                </Flex>
            </DeviceIdProvider>
        </NotificationProvider>
    );
};
